module.exports = __webpack_public_path__ + "assets/img/85cbdc035dc14b71beb3d61f790e59a0.svg";